/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Garage_SaleInputs */

const en_listing_category_garage_sale = /** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage Sale`)
};

const id_listing_category_garage_sale = /** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obral Garasi`)
};

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const es_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const fr_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const de_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const ja_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const zh_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const ar_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const it_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const ru_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const pt_listing_category_garage_sale = en_listing_category_garage_sale;

/** @type {(inputs: Listing_Category_Garage_SaleInputs) => LocalizedString} */
const ko_listing_category_garage_sale = en_listing_category_garage_sale;

/**
* | output |
* | --- |
* | "Garage Sale" |
*
* @param {Listing_Category_Garage_SaleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_garage_sale = /** @type {((inputs?: Listing_Category_Garage_SaleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Garage_SaleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_garage_sale(inputs)
	if (locale === "es") return es_listing_category_garage_sale(inputs)
	if (locale === "fr") return fr_listing_category_garage_sale(inputs)
	if (locale === "de") return de_listing_category_garage_sale(inputs)
	if (locale === "ja") return ja_listing_category_garage_sale(inputs)
	if (locale === "zh") return zh_listing_category_garage_sale(inputs)
	if (locale === "ar") return ar_listing_category_garage_sale(inputs)
	if (locale === "id") return id_listing_category_garage_sale(inputs)
	if (locale === "it") return it_listing_category_garage_sale(inputs)
	if (locale === "ru") return ru_listing_category_garage_sale(inputs)
	if (locale === "pt") return pt_listing_category_garage_sale(inputs)
	return ko_listing_category_garage_sale(inputs)
});